import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Config } from "src/app/utility/config";
@Injectable({
  providedIn: "root",
})
export class CheckinCheckoutService {
  getQRCode() {
    throw new Error("Method not implemented.");
  }
  checkOut(result: any) {
    throw new Error("Method not implemented.");
  }

  constructor(private http: HttpClient, private config: Config) {}

  checkIn(data: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Attendance/SaveUpdateQRT?QRCodeValue=" +
      data +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getallcheckincheckout(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Attendance/GetAttendance?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getallcheckincheckoutByuserId(
    UserId: any,
    FromDate: string,
    toDate: string
  ): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    // const url = this.config.APIUrl + "QRT_Attendance/GetQRTAttednaceByUser?Login_Key=" + this.config.login_Key + "&UserId=" + UserId;

    const url =
      this.config.APIUrl +
      "QRT_Attendance/GetDataByFilter?Login_Key=" +
      this.config.login_Key +
      "&UserId=" +
      UserId +
      "&StartDate=" +
      FromDate +
      "&EndDate=" +
      toDate;

    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getallcheckincheckoutForEmp(UserId: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Attendance/GetQRTAttednaceByUser?Login_Key=" +
      this.config.login_Key +
      "&UserId=" +
      UserId;

    // const url = this.config.APIUrl + "QRT_Attendance/GetDataByFilter?Login_Key=" + this.config.login_Key + "&UserId=" + UserId + "&StartDate=" + FromDate + "&EndDate=" + toDate;

    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getalluser(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "User/GetAll?Login_Key=" +
      this.config.login_Key +
      "&OnlyActive=" +
      true;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  CheckoutAdmin(userId: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Attendance/AdminCheckout?userId=" +
      userId +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, null, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  SaveComments(data): Observable<any> {
    const url =
      this.config.APIUrl +
      "Attendance_Note/SaveUpdateGSTComment?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetCommentById(AttendanceId: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "Attendance_Note/GetCommentsByAttendance_Id?AttendanceId=" +
      AttendanceId +
      "&Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetTimeSheetDataByUser_Id(User_Id: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Attendance/Get_QRTAttendanceByUserId?Login_Key=" +
      this.config.login_Key +
      "&UserId=" +
      User_Id;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
}
